import { render, staticRenderFns } from "./RoHContactForm.vue?vue&type=template&id=7ad5df92&scoped=true&"
import script from "./RoHContactForm.vue?vue&type=script&lang=js&"
export * from "./RoHContactForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ad5df92",
  null
  
)

export default component.exports